import { decamelizeKeys } from 'humps'

import BaseApi from '@/api/base-api'

class MerchantInstoreMaterialDeliveryApi extends BaseApi {
  fetchList = (data) => {
    return this.request(
      {
        method: 'GET',
        path: this.uri + '/deliveries',
        data: data,
      },
      {
        options: {
          cache: true,
        },
      }
    )
  }

  updateStatus = (data) => {
    const dataToBeSent = decamelizeKeys(data)

    return this.request({
      method: 'POST',
      path: this.uri + '/update-status',
      data: dataToBeSent,
    })
  }
}

export default new MerchantInstoreMaterialDeliveryApi(
  '/merchants/instore-material-delivery'
)
